import React from "react";
import Card from "../../../../shared/Card/Card";
import PropTypes from "prop-types";
import Button from "../../../../shared/button/button";
import Loading from "../../../../shared/Loading/Loading";
import { publish } from "pubsub-js";
import eventType from "../../../events/eventType";
import { ACCOUNT_FAMILY_EVENT } from "../../../events/ga/events";

const AdvancedManagementCardWithInput = ({
	content,
	input,
	callouts,
	onNext,
	onCancel,
	dataAuxText,
	isDisabled,
	hasAuxText,
	hasAnyCallout,
	isLoading,
	renderCheckbox
} = props) => {

	const handleEvent = (type) => {
		publish(eventType.ACCOUNT_FAMILY, {
			type: type
		})
	}

	return (
		<Card className="advanced-management-card-with-input" withoutMargin>
			{content}
			<div
				className={`advanced-management-card-with-input__actions${hasAnyCallout ? " advanced-management-card-with-input__actions--margin" : ""
					}`}
			>
				<div className="advanced-management-card-with-input__actions__input-aux-text">
					<div className="advanced-management-card-with-input__actions__input-aux-text--input">
						{input}
					</div>
					{hasAuxText && (
						<div className="advanced-management-card-with-input__actions__input-aux-text--aux-text">
							{dataAuxText}
						</div>
					)}
				</div>
				<div className="advanced-management-card-with-input__actions--buttons">
					<Button onClick={() => {
						handleEvent(ACCOUNT_FAMILY_EVENT.button_cancel_indication)
						onCancel(true)
					}} className="btn-gray-sm-label">
						Cancelar
					</Button>
					<Button
						onClick={() => {
							handleEvent(ACCOUNT_FAMILY_EVENT.button_next)
							onNext()
						}}
						disabled={isDisabled || isLoading}
						className={`btn btn-primary-sm${isLoading ? " is-loading" : ""}`}
					>
						{isLoading ? <Loading width="20px" height="20px" /> : "Avançar"}
					</Button>
				</div>
			</div>
			<div className="advanced-management-card-with-input__checkbox">
				{renderCheckbox}
			</div>
			<div className="advanced-management-card-with-input__callouts">{callouts}</div>
		</Card>
	);
};

AdvancedManagementCardWithInput.prototype = {
	content: PropTypes.any,
	input: PropTypes.any,
	callouts: PropTypes.any,
	onNext: PropTypes.func,
	onCancel: PropTypes.func,
	isDisabled: PropTypes.bool,
	hasAuxText: PropTypes.bool,
	hasAnyCallout: PropTypes.bool
};

export default AdvancedManagementCardWithInput;
